module.exports = __webpack_public_path__ + "img/06_VIP_80px_40px_60px_30px.0913b386.png";